import { render, staticRenderFns } from "./PanelKanban.vue?vue&type=template&id=2eb55fe8&scoped=true"
import script from "./PanelKanban.vue?vue&type=script&lang=js"
export * from "./PanelKanban.vue?vue&type=script&lang=js"
import style0 from "./PanelKanban.vue?vue&type=style&index=0&id=2eb55fe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb55fe8",
  null
  
)

export default component.exports